<mat-form-field #formFieldContainer floatLabel="always"  class="time-recorder-wrapper " >
   <mat-label
    #labelContainer  (click)="toggleTooltip(tooltip)"
    class="{{componentDefinition?.mandatory ? 'mandatory' : ''}}">
    {{componentDefinition?.label}}
  </mat-label>
  <div class="labelToolTipContainer"
       #tooltip="matTooltip"
       matTooltip="{{componentDefinition.label}}"
       [matTooltipDisabled]="showToolTip(tooltip,formFieldContainer,labelContainer)">
  </div>
  <input matInput hidden />
  <div *ngIf="!(groupValues && groupValues.length > 0)"
      class="gbl-time-recorder-checkbox {{(componentDefinition?.linkDocument !== 'never' &&
      objTimeSheet.ckbTimeSheet[userAccountId]) ? 'input-group':''}}">
      <mat-slide-toggle
        [(ngModel)]="objTimeSheet.ckbTimeSheet[userAccountId]"
        [name]="componentDefinition?.name + userAccountId" [id]="componentDefinition?.name + userAccountId"
        (change)="recordTimeSheet(userAccountId)"
        [disabled]="disableTimeSheet || disabled || objTimeSheet.noMatchViewing[userAccountId]">{{objTimeSheet.ckbTimeSheet[userAccountId] ? 'On' : 'Off'}}</mat-slide-toggle>

      <span *ngIf="(componentDefinition?.linkDocument !== 'never' && objTimeSheet.ckbTimeSheet[userAccountId])"
              (click)="openRecordDoc(userAccountId)">
          <a type="button" style="margin-top:-2px;" class="btn btn-fab btn-fab-mini hidden-print"
              href="#" onclick="return false;" target="_top" title="Open record document" disabled="false" >
              <svg style="width: 24px;height:24px;margin-top: 3px;" viewBox="0 0 24 24">
              <path fill="rgba(108, 14, 135, 0.87)" d="M15,13H16.5V15.82L18.94,17.23L18.19,18.53L15,16.69V13M19,
                8H5V19H9.67C9.24,18.09 9,17.07 9,16A7,7 0 0,1 16,9C17.07,9 18.09,9.24 19,9.67V8M5,21C3.89,21 3,20.1 3,
                19V5C3,3.89 3.89,3 5,3H6V1H8V3H16V1H18V3H19A2,2 0 0,1 21,5V11.1C22.24,12.36 23,14.09 23,16A7,7 0 0,
                1 16,23C14.09,23 12.36,22.24 11.1,21H5M16,11.15A4.85,4.85 0 0,0 11.15,16C11.15,18.68 13.32,20.85 16,
                20.85A4.85,4.85 0 0,0 20.85,16C20.85,13.32 18.68,11.15 16,11.15Z"></path>
              </svg>
          </a>
      </span>
  </div>
  <div *ngIf="(groupValues && groupValues.length > 0)" >
     <div *ngFor='let value of groupValues; let i = index;'>
          <div class="form-group label-static" style="padding-bottom: 15px;">
              <label class="control-label"> {{value.name}} </label>
              <mat-slide-toggle
                [(ngModel)]="objTimeSheet.ckbTimeSheet[value.documentId]"
                [name]="componentDefinition?.name + value.documentId" [id]="componentDefinition?.name + value.documentId"
                (change)="recordTimeSheet(value.documentId)"
                [disabled]="disableTimeSheet || disabled || objTimeSheet.noMatchViewing[value.documentId]"
                >{{objTimeSheet.ckbTimeSheet[value.documentId] ? 'On' : 'Off'}}</mat-slide-toggle>

              <div class="gbl-time-recorder-checkbox {{(componentDefinition?.linkDocument !== 'never' &&
                  objTimeSheet.ckbTimeSheet[value.documentId]) ? 'input-group':''}}">
                  <span *ngIf="(componentDefinition?.linkDocument !== 'never' && objTimeSheet.ckbTimeSheet[value.documentId])"
                        (click)="openRecordDoc(value.documentId)">
                    <a type="button" style="margin-top:-2px;" class="btn btn-fab btn-fab-mini hidden-print"
                       href="#" onclick="return false;" target="_top" title="Open record document" disabled="false" >
                        <svg style="width: 24px;height:24px;margin-top: 3px;" viewBox="0 0 24 24">
                        <path fill="rgba(108, 14, 135, 0.87)" d="M15,13H16.5V15.82L18.94,17.23L18.19,18.53L15,16.69V13M19,
                          8H5V19H9.67C9.24,18.09 9,17.07 9,16A7,7 0 0,1 16,9C17.07,9 18.09,9.24 19,9.67V8M5,21C3.89,21 3,20.1 3,
                          19V5C3,3.89 3.89,3 5,3H6V1H8V3H16V1H18V3H19A2,2 0 0,1 21,5V11.1C22.24,12.36 23,14.09 23,16A7,7 0 0,
                          1 16,23C14.09,23 12.36,22.24 11.1,21H5M16,11.15A4.85,4.85 0 0,0 11.15,16C11.15,18.68 13.32,20.85 16,
                          20.85A4.85,4.85 0 0,0 20.85,16C20.85,13.32 18.68,11.15 16,11.15Z"></path>
                        </svg>
                    </a>
                  </span>
              </div>
          </div>
       </div>
  </div>

</mat-form-field>

